import React from 'react';
import { Switch } from 'react-router';
import { Route } from 'react-router-dom';
import Routes from './routes';
import ChangerMotDePasse from './changement-mot-de-passe';
import EcranGestion from './gestion';
import EcranGestionEmployes from './gestion-employes';
import ModifierPersonnePhysique from './modification-personne-physique';
import ModificationAdressePrincipale from './adresse-principale';
import AjouterAdresseSecondaire from './ajouter-adresse-secondaire';
import ModificationAdresseSecondaire from './adresse-secondaire';
import ModificationInformationsCompte from './modifier-informations-compte';
import ModifierQuestionsReponses from './modifier-questions-reponses';
import AjouterPersona from './ajouter-persona';
import { getPath } from '../../../utils/router';
import AjouterEmploye from './ajouter-employe/AjouterEmploye';
import ListeEmployesContainer from './liste-employes/ListeEmployesContainer';
import ModifierEmploye from './modifier-employe/ModifierEmploye';
import ModifierResponsableLegal from './modification-responsable-legal';

const MonCompte = () => {
    return (
        <div>
            <Switch>
                <Route
                    path={getPath(Routes.subroutes.changementMotDePasse)}
                    render={(subProps) => <ChangerMotDePasse {...subProps} />}
                />
                <Route
                    path={getPath(Routes.subroutes.modifierQuestionsReponses)}
                    render={(subProps) => <ModifierQuestionsReponses {...subProps} />}
                />
                <Route
                    path={getPath(Routes.subroutes.ecranGestion)}
                    render={(subProps) => <EcranGestion {...subProps} />}
                />
                <Route
                    path={getPath(Routes.subroutes.ecranGestionCompteEmployes)}
                    render={(subProps) => <EcranGestionEmployes {...subProps} />}
                />
                <Route
                    path={getPath(Routes.subroutes.modifierAdresseSecondaire)}
                    render={(subProps) => <ModificationAdresseSecondaire {...subProps} />}
                />
                <Route
                    path={getPath(Routes.subroutes.ajouterAdresseSecondaire)}
                    render={(subProps) => <AjouterAdresseSecondaire {...subProps} />}
                />
                <Route
                    path={getPath(Routes.subroutes.adressePrincipale)}
                    render={(subProps) => <ModificationAdressePrincipale {...subProps} />}
                />
                <Route
                    path={getPath(Routes.subroutes.modifierPersonnePhysique)}
                    render={(subProps) => <ModifierPersonnePhysique {...subProps} />}
                />
                <Route
                    path={getPath(Routes.subroutes.modifierResponsableLegal)}
                    render={(subProps) => <ModifierResponsableLegal {...subProps} />}
                />
                <Route
                    path={getPath(Routes.subroutes.modifierInformationsCompte)}
                    render={(subProps) => <ModificationInformationsCompte {...subProps} />}
                />

                <Route
                    path={getPath(Routes.subroutes.ajouterPersona)}
                    render={(subProps) => <AjouterPersona {...subProps} />}
                />

                <Route
                    path={getPath(Routes.subroutes.ajouterEmploye)}
                    render={(subProps) => <AjouterEmploye {...subProps} />}
                />

                <Route
                    path={getPath(Routes.subroutes.modifierEmploye)}
                    render={(subProps) => <ModifierEmploye {...subProps} />}
                />

                <Route
                    path={getPath(Routes.subroutes.listeEmployes)}
                    render={(subProps) => <ListeEmployesContainer {...subProps} />}
                />
            </Switch>
        </div>
    );
};

export default MonCompte;
